// ===================================
// KAIXO - Transformación de URLs de Cloudinary
// ===================================
// Inserta transformaciones en una URL de Cloudinary para que sirva el
// contenido optimizado (f_auto, q_auto, w_*) y reducir lag en móviles.
// No modifica URLs que no sean de Cloudinary.

const CLOUDINARY_HOST = 'res.cloudinary.com';

function isCloudinary(url) {
    try {
        const u = new URL(url);
        return u.hostname === CLOUDINARY_HOST;
    } catch {
        return false;
    }
}

/**
 * Inserta transformaciones después de /upload/ en una URL de Cloudinary.
 * Si la URL ya tiene transformaciones, las reemplaza (una única vez para
 * evitar colisiones con la transformación de thumbnail que añade el
 * backend a los Pulsos).
 */
function applyTransform(url, transform) {
    if (!url || !isCloudinary(url)) return url;
    // Pattern: /<asset_type>/upload/<transform?>/<public_id>
    const uploadMarker = '/upload/';
    const idx = url.indexOf(uploadMarker);
    if (idx < 0) return url;
    const head = url.slice(0, idx + uploadMarker.length);
    const tail = url.slice(idx + uploadMarker.length);
    // Si empieza con algo tipo "f_auto,q_auto/" ya tiene transformación. La
    // sustituimos para quedarnos con la que queremos.
    const cleanedTail = /^[a-z0-9_,.:/-]+\//.test(tail) && /^[a-z]{1,5}_/.test(tail)
        ? tail.replace(/^[^/]+\//, '')
        : tail;
    return `${head}${transform}/${cleanedTail}`;
}

/**
 * Video optimizado para WebView Android: calidad auto, formato auto
 * (mp4/webm según device), ancho máximo 720px. Reduce peso 3-5x y
 * evita los "trompicones" del streaming de videos HD sin optimizar.
 */
export function optimizedVideoUrl(url) {
    return applyTransform(url, 'f_auto,q_auto,w_720,c_limit');
}

/**
 * Imagen optimizada para el feed: auto format+quality, max 1080px.
 */
export function optimizedImageUrl(url) {
    return applyTransform(url, 'f_auto,q_auto,w_1080,c_limit');
}
